import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarVisibilityService {
  private _showSidebar = true;
  private _homeInitialized = false;
  private visibilityChangedSubject = new Subject<boolean>();

  get showSidebar(): boolean {
    return this._showSidebar;
  }

  set showSidebar(value: boolean) {
    if (this._showSidebar !== value) {
      this._showSidebar = value;
      this.visibilityChangedSubject.next(value);
    }
  }

  get homeInitialized(): boolean {
    return this._homeInitialized;
  }

  set homeInitialized(value: boolean) {
    this._homeInitialized = value;
  }

  get onVisibilityChanged() {
    return this.visibilityChangedSubject.asObservable();
  }

  ensureVisible(): void {
    if (!this._showSidebar) {
      this._showSidebar = true;
      this.visibilityChangedSubject.next(true);
    }
  }
}

